import { render, staticRenderFns } from "./MemberMouthRecord.vue?vue&type=template&id=67bb8178&scoped=true&"
import script from "./MemberMouthRecord.vue?vue&type=script&lang=js&"
export * from "./MemberMouthRecord.vue?vue&type=script&lang=js&"
import style0 from "./MemberMouthRecord.vue?vue&type=style&index=0&id=67bb8178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bb8178",
  null
  
)

export default component.exports